// extracted by mini-css-extract-plugin
module.exports = {"astrologerModalContent":"AstrologerModal_style_astrologerModalContent__3SzQx","astrologerLoadingModal":"AstrologerModal_style_astrologerLoadingModal__39YHt"};